<div class="flex flex-col gap-4">
  @for (formGroup of typeForms().controls; track $index) {
    <div class="flex justify-between items-center gap-6 p-4 rounded-xl border-1 border-primary-50">
      <div class="flex-1">
        <elcia-text-input [control]="formGroup.controls.nameFr" [label]="'local.french' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="formGroup.controls.nameNl" [label]="'local.dutch' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="formGroup.controls.nameEn" [label]="'local.english' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-product-dropdown [control]="formGroup.controls.productId" [isMulti]="false"/>
      </div>
      <elcia-toggle-switch [control]="formGroup.controls.hasTravelExpenses"
                           [label]="'timesheet-type.has-travel-expenses' | translate"/>

      <elcia-button
        (click)="toggleFormGroup(formGroup.value.id)"
        [icon]="formGroup.enabled ? 'save' : 'edit'"
        [severity]="formGroup.enabled ? 'primary' : 'secondary'"/>
      <elcia-button
        (click)="deleteType(formGroup.value.id)"
        icon="delete"
        severity="danger"
        variant="text"/>
    </div>
  }

  <div class="flex justify-between items-center gap-6 p-4 rounded-xl border-1 border-dashed border-primary-100">
    <div class="flex-1">
      <elcia-text-input [control]="createForm.controls.nameFr" [label]="'local.french' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="createForm.controls.nameNl" [label]="'local.dutch' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="createForm.controls.nameEn" [label]="'local.english' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-product-dropdown [control]="createForm.controls.productId" [isMulti]="false"/>
    </div>
    <elcia-toggle-switch [control]="createForm.controls.hasTravelExpenses"
                         [label]="'timesheet-type.has-travel-expenses' | translate"/>
    <elcia-button
      (click)="submitCreate()"
      [disabled]="createForm.invalid"
      icon="plus"
      severity="primary"/>
    <div class="w-[36px]"></div>
  </div>
</div>
